import React from 'react';
import { Shield, Lock, Activity, CreditCard } from 'react-feather';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function Privacy() {
  return (
    <>
      <Navbar />
      <div className="bg-white text-gray-800 px-6 py-12 max-w-6xl mx-auto">
        <section className="text-center mb-12">
          <h1 className="text-4xl font-bold leading-tight mb-2 bg-gradient-to-r from-slate-400 via-zinc-400 to-stone-800 text-transparent bg-clip-text">
            Privacy You Can Trust
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We are committed to protecting your personal data and ensuring a safe community environment.
          </p>
          <img
            src="/data-privacy.png"
            alt="Privacy Illustration"
            className="mx-auto mt-8 max-h-80 object-contain"
          />
        </section>

        <section className="grid md:grid-cols-2 gap-8">
          <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-md transition">
            <div className="flex items-center gap-4 mb-3">
              <Lock className="w-6 h-6 text-indigo-600" />
              <h2 className="text-xl font-semibold">Data Security</h2>
            </div>
            <p className="text-gray-600">
              Your information is protected with advanced encryption methods and industry-grade security protocols.
            </p>
          </div>

          <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-md transition">
            <div className="flex items-center gap-4 mb-3">
              <Shield className="w-6 h-6 text-indigo-600" />
              <h2 className="text-xl font-semibold">Access Control</h2>
            </div>
            <p className="text-gray-600">
              Role-based access ensures that only verified and authorized users can view or edit sensitive information.
            </p>
          </div>

          <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-md transition">
            <div className="flex items-center gap-4 mb-3">
              <Activity className="w-6 h-6 text-indigo-600" />
              <h2 className="text-xl font-semibold">Activity Monitoring</h2>
            </div>
            <p className="text-gray-600">
              Real-time logs and reporting give communities visibility into system usage and interactions.
            </p>
          </div>

          <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-md transition">
            <div className="flex items-center gap-4 mb-3">
              <CreditCard className="w-6 h-6 text-indigo-600" />
              <h2 className="text-xl font-semibold">Secure Payments</h2>
            </div>
            <p className="text-gray-600">
              Online payments are protected by secure gateways and compliant with the highest standards.
            </p>
          </div>
        </section>

        <section className="text-center mt-16">
          <p className="text-2xl font-bold">
            Built with <span className="text-indigo-600">integrity</span>, for communities that care about privacy.
          </p>
          <p className="mt-4 text-gray-600 max-w-xl mx-auto">
            From day one, Community Portal is designed to meet privacy expectations of HOAs and residents alike.
            Our infrastructure, policies, and feature controls are all built with transparency and protection in mind.
          </p>
          <button className="mt-6 px-6 py-3 bg-indigo-600 text-white rounded-full font-semibold hover:bg-indigo-700">
            Learn More About Our Privacy Practices
          </button>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default Privacy;
